"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INBOX_ERROR_MESSAGES = exports.parseSharedInboxErrorMessage = exports.parseSharedInboxAlreadyConnectedPersonally = exports.parseSharedInboxAlreadyConnected = exports.USER_DECLINED = exports.EXCHANGE_VALIDATE_ERROR = exports.EXCHANGE_VERSION_INVALID = exports.EXCHANGE_URL_INVALID = exports.CONVERSATIONS_CREATE_CONFLICT = exports.SHARED_INBOX_INVALID_DOWNGRADE = exports.RECONNECT_EMAIL_MISMATCH = exports.AUTODISCOVERY_FAILURE = exports.INBOX_VALIDATE_ERROR = exports.IMAP_DISABLED_OR_LOGIN_FAILURE = exports.TRANSIENT = exports.OFFICE_ERROR_INVALID_LICENSE = exports.OFFICE_ERROR_REST_API_NOT_ENABLED_FOR_COMPONENT_SHARED_MAILBOX = exports.OFFICE_ERROR_ORGANIZATION_ACCESS_BLOCKED = exports.OFFICE_ERROR = exports.GMAIL_IMAP_DISABLED = exports.MISSING_DRAFTS_FOLDER = exports.MISSING_INBOX_FOLDER = exports.UNTRUSTED_CERTIFICATES = exports.UNAUTHORIZED = exports.OFFICE_SEND_FAILED = exports.SMTP_MESSAGING = exports.SMTP_SETTINGS_INCORRECT = exports.IMAP_SETTINGS_INCORRECT = exports.IMAP_VALIDATE_ERROR = exports.IMAP_AUTHENTICATION_ERROR = exports.GENERIC_MISSING_FOLDER = exports.GENERIC_IMAP_DISABLED = exports.APP_PASSWORD_REQUIRED = exports.CONNECTIONS_RATE_LIMITED = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _StringValidation = require("../utils/StringValidation");

var _INBOX_ERROR_MESSAGES;

// Backend errors:
var CONNECTIONS_RATE_LIMITED = 'CONNECTIONS_RATE_LIMITED';
exports.CONNECTIONS_RATE_LIMITED = CONNECTIONS_RATE_LIMITED;
var APP_PASSWORD_REQUIRED = 'APP_PASSWORD_REQUIRED';
exports.APP_PASSWORD_REQUIRED = APP_PASSWORD_REQUIRED;
var GENERIC_IMAP_DISABLED = 'GENERIC_IMAP_DISABLED';
exports.GENERIC_IMAP_DISABLED = GENERIC_IMAP_DISABLED;
var GENERIC_MISSING_FOLDER = 'GENERIC_MISSING_FOLDER';
exports.GENERIC_MISSING_FOLDER = GENERIC_MISSING_FOLDER;
var IMAP_AUTHENTICATION_ERROR = 'IMAP_AUTHENTICATION_ERROR';
exports.IMAP_AUTHENTICATION_ERROR = IMAP_AUTHENTICATION_ERROR;
var IMAP_VALIDATE_ERROR = 'IMAP_VALIDATE_ERROR';
exports.IMAP_VALIDATE_ERROR = IMAP_VALIDATE_ERROR;
var IMAP_SETTINGS_INCORRECT = 'IMAP_SETTINGS_INCORRECT';
exports.IMAP_SETTINGS_INCORRECT = IMAP_SETTINGS_INCORRECT;
var SMTP_SETTINGS_INCORRECT = 'SMTP_SETTINGS_INCORRECT';
exports.SMTP_SETTINGS_INCORRECT = SMTP_SETTINGS_INCORRECT;
var SMTP_MESSAGING = 'SMTP_MESSAGING';
exports.SMTP_MESSAGING = SMTP_MESSAGING;
var OFFICE_SEND_FAILED = 'OFFICE_SEND_FAILED';
exports.OFFICE_SEND_FAILED = OFFICE_SEND_FAILED;
var UNAUTHORIZED = 'UNAUTHORIZED';
exports.UNAUTHORIZED = UNAUTHORIZED;
var UNTRUSTED_CERTIFICATES = 'UNTRUSTED_CERTIFICATES';
exports.UNTRUSTED_CERTIFICATES = UNTRUSTED_CERTIFICATES;
var MISSING_INBOX_FOLDER = 'MISSING_INBOX_FOLDER';
exports.MISSING_INBOX_FOLDER = MISSING_INBOX_FOLDER;
var MISSING_DRAFTS_FOLDER = 'MISSING_DRAFTS_FOLDER';
exports.MISSING_DRAFTS_FOLDER = MISSING_DRAFTS_FOLDER;
var GMAIL_IMAP_DISABLED = 'GMAIL_IMAP_DISABLED';
exports.GMAIL_IMAP_DISABLED = GMAIL_IMAP_DISABLED;
var OFFICE_ERROR = 'OFFICE_ERROR';
exports.OFFICE_ERROR = OFFICE_ERROR;
var OFFICE_ERROR_ORGANIZATION_ACCESS_BLOCKED = 'OFFICE_ERROR_ORGANIZATION_ACCESS_BLOCKED';
exports.OFFICE_ERROR_ORGANIZATION_ACCESS_BLOCKED = OFFICE_ERROR_ORGANIZATION_ACCESS_BLOCKED;
var OFFICE_ERROR_REST_API_NOT_ENABLED_FOR_COMPONENT_SHARED_MAILBOX = 'OFFICE_ERROR_REST_API_NOT_ENABLED_FOR_COMPONENT_SHARED_MAILBOX';
exports.OFFICE_ERROR_REST_API_NOT_ENABLED_FOR_COMPONENT_SHARED_MAILBOX = OFFICE_ERROR_REST_API_NOT_ENABLED_FOR_COMPONENT_SHARED_MAILBOX;
var OFFICE_ERROR_INVALID_LICENSE = 'OFFICE_ERROR_INVALID_LICENSE';
exports.OFFICE_ERROR_INVALID_LICENSE = OFFICE_ERROR_INVALID_LICENSE;
var TRANSIENT = 'TRANSIENT';
exports.TRANSIENT = TRANSIENT;
var IMAP_DISABLED_OR_LOGIN_FAILURE = 'IMAP_DISABLED_OR_LOGIN_FAILURE';
exports.IMAP_DISABLED_OR_LOGIN_FAILURE = IMAP_DISABLED_OR_LOGIN_FAILURE;
var INBOX_VALIDATE_ERROR = 'INBOX_VALIDATE_ERROR';
exports.INBOX_VALIDATE_ERROR = INBOX_VALIDATE_ERROR;
var AUTODISCOVERY_FAILURE = 'AUTODISCOVERY_FAILURE';
exports.AUTODISCOVERY_FAILURE = AUTODISCOVERY_FAILURE;
var RECONNECT_EMAIL_MISMATCH = 'RECONNECT_EMAIL_MISMATCH';
exports.RECONNECT_EMAIL_MISMATCH = RECONNECT_EMAIL_MISMATCH;
var SHARED_INBOX_INVALID_DOWNGRADE = 'SHARED_INBOX_INVALID_DOWNGRADE';
exports.SHARED_INBOX_INVALID_DOWNGRADE = SHARED_INBOX_INVALID_DOWNGRADE;
var CONVERSATIONS_CREATE_CONFLICT = 'CONVERSATIONS_CREATE_CONFLICT';
exports.CONVERSATIONS_CREATE_CONFLICT = CONVERSATIONS_CREATE_CONFLICT;
var EXCHANGE_URL_INVALID = 'EXCHANGE_URL_INVALID';
exports.EXCHANGE_URL_INVALID = EXCHANGE_URL_INVALID;
var EXCHANGE_VERSION_INVALID = 'EXCHANGE_VERSION_INVALID';
exports.EXCHANGE_VERSION_INVALID = EXCHANGE_VERSION_INVALID;
var EXCHANGE_VALIDATE_ERROR = 'EXCHANGE_VALIDATE_ERROR'; // Frontend errors:

exports.EXCHANGE_VALIDATE_ERROR = EXCHANGE_VALIDATE_ERROR;
var USER_DECLINED = 'USER_DECLINED';
exports.USER_DECLINED = USER_DECLINED;
var ERROR_STEP_ROUTE = 'InboxConnectUtils.wizard.failure.errorResponse';
var RECONNECT_HELP_URL = 'https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-resolve-an-unavailable-or-unauthorized-inbox-connection-error?hs_preview=hrvZeOCN-5437059821';
var GMAIL_IMAP_DISABLED_URL = 'https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-resolve-an-unavailable-or-unauthorized-inbox-connection-error#unavailable-imap-disabled-in-gmail';
var SHARED_INBOX_DISABLED_URL = 'https://knowledge.hubspot.com/getting-started-with-the-hubspot-crm-free/how-to-disconnect-an-authorized-account-from-the-crm';

var getLangKey = function getLangKey(key) {
  return ERROR_STEP_ROUTE + "." + key;
};

var getDescription = function getDescription(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    description: getLangKey(key),
    options: options
  };
};

var parseSharedInboxAlreadyConnected = function parseSharedInboxAlreadyConnected(message) {
  if (!(0, _StringValidation.isNonEmptyString)(message)) return null; // expected message:
  //    Could not create inbox: support@hubspotters.com is a shared inbox across this portal
  // context:
  //    User A creates shared inbox support@hubspotters.com,
  //    then User B tries to connect support@hubspotters.com as a personal inbox

  var sharedInboxAlreadyConnectedPattern = /^Could not create inbox: (.*?) is a shared inbox across this portal/;
  var sharedInboxAlreadyConnectedMatches = message.match(sharedInboxAlreadyConnectedPattern);

  if (sharedInboxAlreadyConnectedMatches) {
    return {
      emailAddress: sharedInboxAlreadyConnectedMatches[1]
    };
  }

  return null;
};

exports.parseSharedInboxAlreadyConnected = parseSharedInboxAlreadyConnected;

var parseSharedInboxAlreadyConnectedPersonally = function parseSharedInboxAlreadyConnectedPersonally(message) {
  if (!(0, _StringValidation.isNonEmptyString)(message)) return null; // expected message:
  //    Could not create inbox: Users [userA@hubspotters.com] must remove
  //    inbox with email support@hubspotters.com before continuing
  // context:
  //    User A creates a personal inbox support@hubspotters.com,
  //    then User B tries to connect support@hubspotters.com as a shared inbox

  var sharedInboxMustRemovePattern = /^Could not create inbox: Users \[(.*?)\] must remove inbox with email (.*?) before continuing/;
  var sharedInboxMustRemoveMatches = message.match(sharedInboxMustRemovePattern);

  if (sharedInboxMustRemoveMatches) {
    var usersEmailsCSV = sharedInboxMustRemoveMatches[1];
    var emailAddress = sharedInboxMustRemoveMatches[2];
    var usersEmails = (0, _StringValidation.isNonEmptyString)(usersEmailsCSV) && usersEmailsCSV.split(', ');
    return {
      usersEmails: usersEmails,
      usersEmailsCSV: usersEmailsCSV,
      emailAddress: emailAddress
    };
  }

  return null;
};

exports.parseSharedInboxAlreadyConnectedPersonally = parseSharedInboxAlreadyConnectedPersonally;

var parseSharedInboxErrorMessage = function parseSharedInboxErrorMessage(message) {
  var sharedInboxAlreadyConnected = parseSharedInboxAlreadyConnected(message);

  if (sharedInboxAlreadyConnected) {
    return getDescription('sharedInbox.alreadyConnected', sharedInboxAlreadyConnected);
  }

  var sharedInboxMustRemove = parseSharedInboxAlreadyConnectedPersonally(message);

  if (sharedInboxMustRemove) {
    var emailAddress = sharedInboxMustRemove.emailAddress,
        usersEmailsCSV = sharedInboxMustRemove.usersEmailsCSV;
    return getDescription('sharedInbox.alreadyConnectedAsPersonal', {
      emailAddress: emailAddress,
      usersEmailsCSV: usersEmailsCSV,
      link: SHARED_INBOX_DISABLED_URL
    });
  }

  return null;
};

exports.parseSharedInboxErrorMessage = parseSharedInboxErrorMessage;
var reconnect = getDescription('reconnect');
var updateYourInbox = getDescription('updateYourInbox', {
  link: RECONNECT_HELP_URL
});
var reachOutToOfficeAdmin = getDescription('reachOutToOfficeAdmin');
var invalidLicense = getDescription('invalidLicense');
var enableImap = getDescription('enableImap', {
  link: GMAIL_IMAP_DISABLED_URL
});
var testEmailFailed = getDescription('testEmailFailed');
var invalidDowngrade = getDescription('sharedInbox.invalidDowngrade');
var conversationsConflict = getDescription('sharedInbox.conversationsConflict');
var INBOX_ERROR_MESSAGES = (_INBOX_ERROR_MESSAGES = {}, (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, UNAUTHORIZED, reconnect), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, INBOX_VALIDATE_ERROR, reconnect), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, MISSING_INBOX_FOLDER, updateYourInbox), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, MISSING_DRAFTS_FOLDER, updateYourInbox), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, OFFICE_ERROR, reconnect), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, OFFICE_ERROR_ORGANIZATION_ACCESS_BLOCKED, reachOutToOfficeAdmin), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, OFFICE_ERROR_REST_API_NOT_ENABLED_FOR_COMPONENT_SHARED_MAILBOX, updateYourInbox), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, OFFICE_ERROR_INVALID_LICENSE, invalidLicense), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, TRANSIENT, reconnect), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, GMAIL_IMAP_DISABLED, enableImap), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, SMTP_MESSAGING, testEmailFailed), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, OFFICE_SEND_FAILED, testEmailFailed), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, SHARED_INBOX_INVALID_DOWNGRADE, invalidDowngrade), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, CONVERSATIONS_CREATE_CONFLICT, conversationsConflict), (0, _defineProperty2.default)(_INBOX_ERROR_MESSAGES, "error", reconnect), _INBOX_ERROR_MESSAGES);
exports.INBOX_ERROR_MESSAGES = INBOX_ERROR_MESSAGES;